<h2 style="margin:5px 0 10px 0;">Create a New Attribute Group</h2>
<form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
    <table class="attribute-full-width">
        <tr>
            <td>
                <mat-form-field>
                    <input
                        [attr.data-testid]="'id_text'"
                        formControlName="id"
                        matInput
                        required
                        placeholder="Id"
                        pattern="^[A-Z_0-9]*$"
                        (focusout)="findGroupExists()"
                    >
                    <mat-error *ngIf="form.controls['id'].invalid && !form.controls['id'].value">
                        Please enter a Standard Id
                    </mat-error>
                    <mat-error *ngIf="form.controls['id'].errors?.pattern && form.controls['id'].value">
                        Please enter a Valid Standard Id
                    </mat-error>
                    <mat-error *ngIf="form.controls['id'].errors?.idExists && form.controls['id'].touched">
                        Id already exists! Create a new one.
                    </mat-error>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field>
                    <input
                        [attr.data-testid]="'name_text'"
                        formControlName="name"
                        matInput
                        required
                        placeholder="Name"
                        [pattern]="spaceValidatorPattern"
                        (focusout)="findNameExists()"
                    >
                    <mat-error *ngIf="form.controls['name'].invalid && !form.controls['name'].value">
                        Please enter a Name
                    </mat-error>
                    <mat-error *ngIf="form.controls['name'].errors?.pattern && form.controls['name'].value">
                        Please enter a Valid Name
                    </mat-error>
                    <mat-error *ngIf="form.controls['name'].errors?.nameExists && form.controls['name'].touched">
                        Name already exists! Create a new one.
                    </mat-error>
                </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field>
                    <textarea
                        #message
                        [attr.data-testid]="'description_textarea'"
                        formControlName="description"
                        matInput
                        [pattern]="spaceValidatorPattern"
                        maxlength="256"
                        placeholder="Description"
                        required
                    ></textarea>
                    <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
                    <mat-error *ngIf="form.controls['description'].invalid && !form.controls['description'].value">
                        Please enter a Description
                    </mat-error>
                </mat-form-field>
            </td>
        </tr>
    </table>
    <div  style="margin-top: 30px;" class="flex-center-center">
        <button
            [attr.data-testid]="'cancel_button'"
            class="button-color"
            mat-raised-button
            matTooltip="Cancel creating Attribute Group"
            style="margin-right: 60px;"
            type="button"
            (click)="onNoClick()"
        >Cancel</button>
        <button
            [attr.data-testid]="'save_button'"
            class="button-color"
            mat-raised-button
            matTooltip="Save"
            type="submit"
            [disabled]="isReadOnly | async"
        >Save</button>
    </div>
</form>
